module.exports = {"320106001":"宁海路街道","320106002":"华侨路街道","320106003":"湖南路街道","320106004":"中央门街道","320106005":"挹江门街道","320106006":"江东街道","320106007":"凤凰街道","320106008":"阅江楼街道","320106009":"热河南路街道","320106010":"幕府山街道","320106011":"建宁路街道","320106012":"宝塔桥街道","320106013":"小市街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320106.json
// module id = 766
// module chunks = 0